/**
 * 行政区域接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AdministrativeDivisionService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }
 
  //#region 行政区域接口
  /**
   * 查询行政区域所有信息
   * @param param
   * @returns {Observable<any>}
   */
  getAdministrativeDivisionList(param) {
    const url = this.prefix + 'region/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 查看行政区域信息
   * @param param
   * @returns {Observable<any>}
   */
  getAdministrativeDivision(param) {
    const url = this.prefix + 'region/queryById';
    return this.http.Post(url, param);
  }

  /**
   * 更新行政区域信息
   * @param param
   * @returns {Observable<any>}
   */
  updateAdministrativeDivision(param) {
    const url = this.prefix + 'region/updateById';
    return this.http.Post(url, param);
  }

  /**
   * 删除行政区域单个信息
   * @param param
   * @returns {Observable<any>}
   */
  deleteAdministrativeDivision(param) {
    const url = this.prefix + 'region/deleteBatch';
    return this.http.Post(url, param);
  }

  /**
   * 增加行政区域单个信息
   * @param param
   * @returns {Observable<any>}
   */
  saveAdministrativeDivision(param) {
    const url = this.prefix + 'region/save';
    return this.http.Post(url, param);
  }

  //#endregion



}
